<template>
  <section>
    <b-collapse class="card" :open.sync="isOpen">
      <div slot="trigger" slot-scope="props" class="card-header">
        <p class="card-header-title has-text-weight-light">Change values for this counter</p>
        <a class="card-header-icon">
          <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
        </a>
      </div>
      <div class="card-content">
        <div class="content">
          <p>Usually, I earn about</p>
          <div class="columns">
            <b-input
              placeholder="$€¥"
              type="number"
              min="0"
              :value="formValues.tickValue"
              @input="tickValueUpdated"
            ></b-input>

            <b-field>
              <b-select :value="formValues.currency" @input="currencyChanged">
                <option
                  v-for="currency in currencyValues"
                  :value="currency"
                  :key="currency"
                >{{ currency }}</option>
              </b-select>
            </b-field>

            <b-field>
              <b-select :value="currentFrequencyObject" @input="frequencyChange">
                <option
                  v-for="frequency in frequencyValues"
                  :value="frequency.value"
                  :key="frequency.name"
                >{{ frequency.name }}</option>
              </b-select>
            </b-field>
          </div>
          <hr>
          <div class="columns">
            <div class="column">
              <p>Today, I started at:
                <b-timepicker :value="currentTime" inline @input="startTimeUpdated"></b-timepicker>
              </p>
            </div>
          </div>
        </div>
      </div>
      <footer class="card-footer"></footer>
    </b-collapse>
  </section>
</template>

<script>
import helpers from '../utils/helpers.js';
export default {
	props: ['formValues'],
	data() {
		return {
			time: new Date(),
			isOpen: false,
			currencyValues: ['€', '$', '¥', '£'],
			frequencyValues: [
				{value: 3600, name: 'per hour'},
				{value: 28800, name: 'per 8 hours'},
				{value: 86400, name: 'per day (24 hrs)'},
				{value: 60, name: 'per minute'},
				{value: 144000, name: 'per week (5*8 hours)'},
				{value: 576000, name: 'per month (20*8 hours)'},
			],
		};
	},
	computed: {
		currentTime: function() {
			return helpers.createTimeObjectFrom(this.formValues.startHours, this.formValues.startMinutes);
		},
		currentFrequencyObject: function() {
			return this.formValues.frequency;
		},
	},
	methods: {
		startTimeUpdated: function(newStartTime) {
			this.$emit('startTimeSet', newStartTime);
		},
		tickValueUpdated: function(newTickValue) {
			this.$emit('tickValueUpdated', newTickValue);
		},
		currencyChanged: function(newCurrency) {
			this.$emit('currencyChanged', newCurrency);
		},
		frequencyChange: function(newFrequency) {
			this.$emit('frequencyChanged', newFrequency);
		},
	},
};
</script>

<style scoped>
</style>
